import { z } from 'zod';
import { createToolSignature, ToolSignature } from './tool-signature';
import { ProspectSchema } from '../schemas/prospect.schema';
import { ChannelType } from '@zaplify/channel-accounts-shared';

export const getMessageGenerationContextToolSignature = createToolSignature({
    name: 'getMessageGenerationContextTool',
    description: 'Get the context of the message generation',
    inputSchema: z.object({
        userId: z.string(),
        prospectId: z.string(),
        channelType: z.enum([ChannelType.LINKEDIN, ChannelType.EMAIL]),
        chosenPath: z.string().nullable(),
        feedback: z.string().nullable(),
        messageToRegenerateSubjectLine: z.string().nullable(),
        messageToRegenerateContent: z.string().nullable(),
    }),
    outputSchema: z.object({
        globalMemories: z.string(),
        playbookMemories: z.string(),
        conversationMemories: z.string(),
        conversationHistory: z.string(),
        assistantSettings: z.object({
            purpose: z.string(),
            context: z.string().nullable(),
        }),
        userName: z.string(),
        prospect: ProspectSchema,
        chosenPath: z.string().nullable(),
        feedback: z.string().nullable(),
        messageToRegenerateSubjectLine: z.string().nullable(),
        messageToRegenerateContent: z.string().nullable(),
    }),
    toolCallUi: (input) => `Getting conversation context`,
});
